export const messages = {
  en: {
    reportRepair: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      beginStartTimePlaceholder: 'Please select creation start time',
      beginEndTimePlaceholder: 'Please select creation end time',
      finishStartTimePlaceholder: 'Please select completion start time',
      finishEndTimePlaceholder: 'Please select completion end time',
      communityPlaceholder: 'Please select community',
      search: 'Search',
      reset: 'Reset',
      staffPlaceholder: 'Please select staff name',
      statePlaceholder: 'Please select status',
      reportTitle: 'Repair Summary Report',
      tooltip: 'Display work order summary by staff dimension',
      export: 'Export',
      repairId: 'Repair ID',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      dealing: 'Processing (count)',
      dispatch: 'Dispatch (count)',
      transfer: 'Transfer (count)',
      chargeback: 'Chargeback (count)',
      returnVisit: 'Return Visit (count)',
      finished: 'Finished (count)',
      score: 'Staff Score',
      statistics: 'Statistics',
      timeError: 'End time must be greater than start time'
    }
  },
  zh: {
    reportRepair: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      beginStartTimePlaceholder: '请选择创建开始时间',
      beginEndTimePlaceholder: '请选择创建结束时间',
      finishStartTimePlaceholder: '请选择完结开始时间',
      finishEndTimePlaceholder: '请选择完结结束时间',
      communityPlaceholder: '请选择小区',
      search: '查询',
      reset: '重置',
      staffPlaceholder: '请选择员工姓名',
      statePlaceholder: '请选择状态',
      reportTitle: '报修汇总表',
      tooltip: '以员工为维度，展示员工处理工单情况汇总',
      export: '导出',
      repairId: '报修编号',
      staffId: '员工ID',
      staffName: '员工姓名',
      dealing: '处理中(条)',
      dispatch: '派单(条)',
      transfer: '转单(条)',
      chargeback: '退单(条)',
      returnVisit: '已回访(条)',
      finished: '已完结(条)',
      score: '员工评分',
      statistics: '统计',
timeError: '結束時間必須大於開始時間'
    }
  },
  'zh-TW': {
    reportRepair: {
      queryCondition: '查詢條件',
      hide: '隱藏',
      more: '更多',
      beginStartTimePlaceholder: '請選擇創建開始時間',
      beginEndTimePlaceholder: '請選擇創建結束時間',
      finishStartTimePlaceholder: '請選擇完結開始時間',
      finishEndTimePlaceholder: '請選擇完結結束時間',
      communityPlaceholder: '請選擇小區',
      search: '查詢',
      reset: '重置',
      staffPlaceholder: '請選擇員工姓名',
      statePlaceholder: '請選擇狀態',
      reportTitle: '報修匯總表',
      tooltip: '以員工為維度，展示員工處理工單情況匯總',
      export: '匯出',
      repairId: '報修編號',
      staffId: '員工ID',
      staffName: '員工姓名',
      dealing: '處理中(條)',
      dispatch: '派單(條)',
      transfer: '轉單(條)',
      chargeback: '退單(條)',
      returnVisit: '已回訪(條)',
      finished: '已完結(條)',
      score: '員工評分',
      statistics: '統計',
      timeError: '結束時間必須大於開始時間'
    }
  }
}